import { useTranslation } from 'react-i18next';
import averageInteractionsPerWeek from '../../../assets/average-interactions-per-week.svg';
import averageSessionsPerWeek from '../../../assets/average-sessions-per-week.svg';
import TrendArrow from './TrendArrow';
import { getDisplayValue } from './utils';
import DataCard, { DataCardDisplayProps } from './DataCard';

type AveragePerWeekProps = DataCardDisplayProps;

const AveragePerWeekCard = ({
  change,
  value,
  type,
  showEmpty = false,
  noPreviousData = false,
  isRXEnabled = false,
}: AveragePerWeekProps) => {
  const { t } = useTranslation();
  const isSessions = type === 'sessions';
  const interactionsLabel = isRXEnabled
    ? 'analytics.averageInteractionsPerWeek'
    : 'analytics.averageScreenClicksPerWeek';
  const label = isSessions
    ? 'analytics.averageEngagedShoppersPerWeek'
    : interactionsLabel;

  return (
    <DataCard type={type}>
      <img
        className="image"
        src={isSessions ? averageSessionsPerWeek : averageInteractionsPerWeek}
        alt={t(label)!}
      />
      <div className="w-full flex text">
        <div className="ml-6 max-w-[160px]">
          <p className="display-value">
            {showEmpty ? '— —' : getDisplayValue(value)}
          </p>
          <p className="text-sm font-semibold align-top">{t(label)}</p>
          {showEmpty && <p className="text-xs">{t('analytics.noValidData')}</p>}
          {!showEmpty && (
            <>
              {noPreviousData ? (
                <p className="text-xs">
                  {t('analytics.trafficAwarenessPage.overview.noPrevious')}
                </p>
              ) : (
                <TrendArrow
                  change={change}
                  label={t('analytics.fromThePreviousPeriod')}
                />
              )}
            </>
          )}
        </div>
      </div>
    </DataCard>
  );
};

export default AveragePerWeekCard;
